// @ts-ignore
window.metorial_config = {
  VITE_API_HOST: import.meta.env.VITE_API_HOST,
  VITE_AUTH_HOST: import.meta.env.VITE_AUTH_HOST,
  VITE_FRONTEND_HOST: import.meta.env.VITE_FRONTEND_HOST,
  PROD: import.meta.env.PROD
};
